/**
 * User API Service (Admin only)
 */

import { apiClient } from './client'
import type {
  UserCreate,
  UserUpdate,
  UserResponse,
} from '@/types/api'

interface ListUsersParams {
  skip?: number
  limit?: number
  include_inactive?: boolean
}

/**
 * Get list of users (admin only)
 */
export async function getUsers(params?: ListUsersParams): Promise<UserResponse[]> {
  return apiClient.get<UserResponse[]>('/users', { params })
}

/**
 * Get a single user by ID (admin only)
 */
export async function getUser(id: string): Promise<UserResponse> {
  return apiClient.get<UserResponse>(`/users/${id}`)
}

/**
 * Create a new user (admin only)
 */
export async function createUser(data: UserCreate): Promise<UserResponse> {
  return apiClient.post<UserResponse>('/users', data)
}

/**
 * Update an existing user (admin only)
 */
export async function updateUser(id: string, data: UserUpdate): Promise<UserResponse> {
  return apiClient.put<UserResponse>(`/users/${id}`, data)
}

/**
 * Reset password for a user (admin only)
 */
export async function resetPassword(id: string, password: string): Promise<UserResponse> {
  return apiClient.post<UserResponse>(`/users/${id}/reset-password`, { password })
}

/**
 * Deactivate a user (admin only)
 */
export async function deactivateUser(id: string): Promise<UserResponse> {
  return apiClient.post<UserResponse>(`/users/${id}/deactivate`)
}

/**
 * Activate a user (admin only)
 */
export async function activateUser(id: string): Promise<UserResponse> {
  return apiClient.post<UserResponse>(`/users/${id}/activate`)
}

export const userService = {
  getUsers,
  getUser,
  createUser,
  updateUser,
  resetPassword,
  deactivateUser,
  activateUser,
}
